import {Outlet, useLocation} from "react-router-dom";
import {Flowbite, Navbar} from 'flowbite-react';
import LogoDark from '../assets/images/logo-dark.png'
import {ToastContainer} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import React from "react";
import GitHubCorner from 'react-github-corner';

const Layout = () => {
    const location = useLocation();
    const {pathname} = location;
    const splitLocation = pathname.split("/");

    return (
        <Flowbite theme={{dark: true}}>
            <ToastContainer/>
            <Navbar border className="border-t-0">
                <Navbar.Brand>
                    <img
                        alt="Formy Logo"
                        className="mr-3 h-10"
                        src={LogoDark}
                    />
                    <span
                        className="self-center whitespace-nowrap text-xl font-semibold dark:text-white"> Formy </span>
                </Navbar.Brand>
                <Navbar.Toggle/>
                <Navbar.Collapse>
                    <Navbar.Link href="/" className={splitLocation[1] === "" ? "active" : ""}>
                        HOME
                    </Navbar.Link>
                    <Navbar.Link href="/documentation" className={splitLocation[1] === "documentation" ? "active" : ""}>
                        DOCS
                    </Navbar.Link>
                </Navbar.Collapse>
            </Navbar>
            <GitHubCorner
                href="https://github.com/abmohajeri/formy"
                target="_blank"
                rel="noopener noreferrer"
                bannerColor="#000"
                octoColor="#fff"
                size={140}
                direction="right"
            />
            <Outlet/>
            <footer data-testid="flowbite-footer"
                    className="w-full rounded-lg bg-white dark:bg-gray-900 shadow md:flex md:items-center md:justify-center w-full p-6 rounded-none">
                <div className="container text-center">
                    <div className="w-full justify-between sm:flex sm:items-center sm:justify-between">
                        <a data-testid="flowbite-footer-brand" href="/"
                           className="mb-4 flex items-center sm:mb-0">
                            <img alt="Formy Logo" src={LogoDark}
                                 className="mr-3 h-9"/>
                            <span data-testid="flowbite-footer-brand-span"
                                  className="self-center whitespace-nowrap text-2xl font-semibold text-gray-800 dark:text-white">
                                Formy
                            </span>
                        </a>
                        <ul data-testid="footer-groupLink" className="flex flex-wrap text-sm text-gray-500 dark:text-white">
                            <li className="last:mr-0 mr-6"><a href="/" className="hover:underline">HOME</a></li>
                            <li className="last:mr-0 mr-6"><a href="/documentation" className="hover:underline">DOCS</a></li>
                        </ul>
                    </div>
                    <hr data-testid="footer-divider"
                        className="w-full my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-8"/>
                    <div data-testid="flowbite-footer-copyright"
                         className="text-sm text-white sm:text-center">
                        © 2025 <a href="/" className="hover:underline">Formy</a>. All rights reserved.
                    </div>
                </div>
            </footer>
        </Flowbite>
    )
};

export default Layout;